import { useThemeContext } from "../utils/services/HandleThemeToggling";

export const OneRaceHubLogo = ({
  classNames,
  collapsed,
  testId,
}: {
  classNames: string;
  collapsed: boolean;
  testId: string;
}) => {
  const { isDarkMode } = useThemeContext();
  const fillColorLeft = isDarkMode ? "#f9f7f5" : "#000c2b";
  const fillColorRight = isDarkMode ? "#f9f7f5" : "#0f47ea";

  return (
    <div className={classNames} data-testid={testId}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={collapsed ? "0 0 429.71 429.71" : "0 0 2622.98 429.71"}
        className="w-full h-full">
        {!collapsed && (
          <>
            <g>
              <path
                fill={fillColorLeft}
                d="M481.95,215.89c0-76.07,45.78-123.56,119.44-123.56s119.43,47.5,119.43,123.56-45.78,122.88-119.43,122.88-119.44-47.15-119.44-122.88h0ZM656.45,215.89c0-45.09-19.96-72.28-55.07-72.28s-55.07,27.19-55.07,72.28,20.31,71.6,55.07,71.6,55.07-26.85,55.07-71.6h0Z"
              />
              <path
                fill={fillColorLeft}
                d="M736.28,98.52h66.43l62.99,109.45,19.28,41.65-3.44-151.1h62.65v234.05h-66.43l-62.99-109.8-18.93-40.95,3.44,150.75h-62.99V98.52h-.01Z"
              />
              <path
                fill={fillColorLeft}
                d="M966.86,98.52h171.06v49.56h-108.07v40.96h94.31v48.18h-94.31v45.78h108.07v49.56h-171.06V98.52h0Z"
              />
            </g>
            <g>
              <path
                fill={fillColorRight}
                d="M1197.46,98.52h84.33c49.22,0,80.54,25.47,80.54,66.08,0,26.85-13.08,45.78-35.11,55.76,15.14,6.88,23.06,19.62,28.91,42.68l17.55,69.53h-33.39l-14.8-63.33c-6.88-29.26-18.59-34.76-46.81-34.76h-49.56v98.09h-31.67V98.52h.01ZM1229.13,124.33v84.33h51.29c30.97,0,49.22-16.52,49.22-42.34s-18.24-41.99-48.53-41.99h-51.98Z"
              />
              <path
                fill={fillColorRight}
                d="M1541.63,276.46h-112.21l-22.03,56.1h-31.32l91.9-234.05h36.48l92.25,234.05h-33.05l-22.03-56.1h.01ZM1439.06,251h92.93l-39.58-101.2-6.88-20.65-6.88,20.65-39.58,101.2h-.01Z"
              />
              <path
                fill={fillColorRight}
                d="M1760.87,165.98c-8.61-28.57-33.05-44.4-62.99-44.4-45.78,0-72.97,35.8-72.97,94.31s26.85,93.62,72.97,93.62c28.91,0,52.32-14.8,62.3-43.03h33.39c-13.08,44.4-51.29,70.21-96.03,70.21-65.4,0-104.98-45.78-104.98-120.81s40.27-121.5,106.36-121.5c45.09,0,83.64,24.78,95,71.6h-33.05Z"
              />
              <path
                fill={fillColorRight}
                d="M1820.04,98.52h158.67v25.81h-127.01v74h114.27v25.81h-114.27v82.61h127.01v25.81h-158.67V98.52Z"
              />
              <path
                fill={fillColorRight}
                d="M2005.19,98.52h31.67v100.5h122.53v-100.5h31.67v234.05h-31.67v-107.73h-122.53v107.73h-31.67V98.52h0Z"
              />
              <path
                fill={fillColorRight}
                d="M2320.11,336.7c-57.82,0-93.62-35.45-93.62-93.27V98.52h32.01v144.91c0,42.33,23.06,67.8,61.61,67.8s61.61-25.81,61.61-67.8V98.52h31.67v144.91c0,57.82-35.8,93.27-93.28,93.27h0Z"
              />
              <path
                fill={fillColorRight}
                d="M2448.81,98.52h82.27c48.18,0,79.16,24.1,79.16,62.3,0,22.37-12.05,40.27-34.42,48.87,30.63,7.92,47.15,29.26,47.15,57.13,0,41.65-30.29,65.74-80.2,65.74h-93.97V98.52h.01ZM2480.48,123.99v76.07h49.22c30.29,0,47.84-15.14,47.84-37.52,0-23.75-17.9-38.55-47.15-38.55h-49.91ZM2480.48,225.52v81.57h61.61c29.95,0,48.53-16.18,48.53-40.95s-20.31-40.62-53.35-40.62h-56.79Z"
              />
            </g>
          </>
        )}
        <g>
          <polygon
            fill={fillColorLeft}
            points="265.24 291.42 168.25 347.42 168.25 429.71 168.25 429.71 336.51 332.57 336.51 138.29 265.24 179.43 265.24 291.42"
          />
          <polygon
            fill={fillColorLeft}
            points="71.27 209.13 71.27 97.14 0 56 0 250.28 168.25 347.42 168.25 265.13 71.27 209.13"
          />
          <polygon
            fill={fillColorLeft}
            points="239.52 82.29 336.51 138.29 407.77 97.14 239.52 0 71.27 97.14 142.53 138.29 239.52 82.29"
          />
        </g>
      </svg>
    </div>
  );
};
